import axios from 'axios';
import router from './router/index'
import { getCookie } from './utils/tool'

// 响应拦截器
axios.interceptors.request.use(function (config) {
    let token = getCookie('token')
    if (token) {
      config.headers['Authorization'] = "Bearer " + token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config;
  },  error => {
    // 对请求错误做些什么
    Promise.reject(error);
  });

  axios.interceptors.response.use(function (res) {
    // 在这里实现响应后的处理
    if(res.data.errcode === 0) {
   
    }
    return res
   })

   export default axios